import React, { useEffect } from "react";
import "./Notification.css";

export default function Notification({ message, onClose }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 3000);

    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className="notification">
      <div className="notification-content">
        <span className="notification-text">{message}</span>
      </div>
    </div>
  );
}
